var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.625 11.75V8h1.094l.156-1.25h-1.25v-.742c0-.182.036-.313.107-.39.072-.079.232-.118.479-.118h.664V4.25H8.781c-.638 0-1.094.14-1.367.42-.273.28-.41.693-.41 1.24v.84h-.879V8h.879v3.75h1.621z","fill":"currentColor","fillRule":"nonzero"}));
}

FacebookInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
